<template>
  <div class="btn-group rounded w-100">
    <router-link
      v-for="(item, i) in langs"
      :key="i"
      :to="{
        params: { ...$route.props, lang: getLangAbbr(item) }
      }"
      :class="{
        'wet-switch-lang-active': lang === item.lang
      }"
      type="button"
      class="btn border"
    ><img v-if="showFlags"
      :alt="item.title"
      :src="item.icon"
      class="me-2"
      width="18"
      height="12"
    > {{ item.title }}</router-link>
  </div>
</template>
<script>
import configEnv from "@/enums/configEnv";
import getLanguageAbbreviation from "@/mixins/getLanguageAbbreviation";

export default {
  mixins: [getLanguageAbbreviation],
  props: {
    langs: {
      type: Array,
      default: () => [],
    },
    lang: {
      type: String,
      default: 'en',
    },
  },
  data() {
    return {
      showFlags: configEnv.showFlags,
    };
  },
};
</script>
<style lang="scss">
  .wet-switch-lang-active {
    font-weight: bold;
    border-color: var(--primary)!important;
    color: var(--primary);
    background-color: var(--white);
    z-index: 1;
  }
</style>
